/*eslint-disable */
//Polyfill for document.contains.
const contains = () => {
  if (typeof HTMLDocument !== "undefined" && !HTMLDocument.prototype.contains) {
    HTMLDocument.prototype.contains = function (node) {
      if (!(0 in arguments)) {
        throw new TypeError("1 argument is required");
      }

      do {
        if (this === node) {
          return true;
        }
      } while ((node = node && node.parentNode));
      return false;
    };
  } else if (!document.contains) {
    Document.prototype.contains = function (node) {
      if (!(0 in arguments)) {
        throw new TypeError("1 argument is required");
      }

      do {
        if (this === node) {
          return true;
        }
      } while ((node = node && node.parentNode));
      return false;
    };
  };
};
export default contains;
